import { getBandWidthDate } from './getBandwidthDate';

/**
 * This function is used to get the expected end date of an asset.
 * @param expectedEndDateStart - The start date of the expected end date.
 * @param expectedEndDate - The end date of the expected end date.
 * @param callbackFunction - The function to format the date.
 * @returns The expected end date.
 */
export const bandWidthDateFormatter = ({
  bandWidthStartDate,
  bandWidthEndDate,
  callbackFunction,
}: {
  bandWidthStartDate?: string | null | undefined;
  bandWidthEndDate?: string | null | undefined;
  callbackFunction: (date: string | null | undefined) => string;
}) => {
  const { resolvedStartDate, resolvedEndDate } = getBandWidthDate({
    resolvedStartDate: bandWidthStartDate,
    resolvedDate: bandWidthEndDate,
  });

  if (resolvedStartDate && resolvedEndDate) {
    return `${callbackFunction(resolvedStartDate)} - ${callbackFunction(resolvedEndDate)}`;
  }

  const date = `${callbackFunction(resolvedStartDate || resolvedEndDate)}`;

  return date;
};
